"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var rql_1 = require("../schemas/rql");
var BaseClient = /** @class */ (function () {
    function BaseClient() {
        this.defaultHeaders = {};
    }
    BaseClient.prototype.setDefaultHeaders = function (headers) {
        this.defaultHeaders = tslib_1.__assign(tslib_1.__assign({}, headers), { 'X-Reverb-App': rql_1.core_apimessages_Channel.REVERB });
    };
    BaseClient.prototype.beforeRequest = function () {
        // no-op by default -- use this to set up request time
        // headers
    };
    BaseClient.prototype.get = function (url, options) {
        if (options === void 0) { options = {}; }
        return this.request('GET', url, options);
    };
    BaseClient.prototype.post = function (url, body, options) {
        if (options === void 0) { options = {}; }
        if (body) {
            options.body = JSON.stringify(body);
        }
        return this.request('POST', url, options);
    };
    BaseClient.prototype.put = function (url, body, options) {
        if (options === void 0) { options = {}; }
        if (body) {
            options.body = JSON.stringify(body);
        }
        return this.request('PUT', url, options);
    };
    BaseClient.prototype.destroy = function (url, options) {
        if (options === void 0) { options = {}; }
        return this.request('DELETE', url, options);
    };
    BaseClient.prototype.request = function (method, url, options) {
        if (options === void 0) { options = {}; }
        this.beforeRequest();
        var headers = tslib_1.__assign(tslib_1.__assign({}, this.defaultHeaders), options.headers);
        options.headers = headers;
        options.method = method;
        return new Promise(function (resolve, reject) {
            fetch(url, options).then(function (r) {
                if (r.ok) {
                    resolve(r.json()); // TODO: return status
                }
                else {
                    r.json().then(function (data) {
                        reject({
                            data: data,
                            status: r.status,
                        });
                    }).catch(function () {
                        reject({ status: r.status });
                    });
                }
            }).catch(function (e) {
                reject(e);
            });
        });
    };
    return BaseClient;
}());
exports.default = BaseClient;
//# sourceMappingURL=base_client.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/lib/base_client.js
// module id = XzMt
// module chunks = 20 21 22